import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../common/global-constants";
import { BOToothType } from "../models/odo/BOToothType.model";

@Injectable({
  providedIn: 'root'
})
export class ToothTypeService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/ToothType';

    constructor(private http:HttpClient){}

    getAll():Observable<BOToothType[]>{
        return this.http.get<BOToothType[]>(this.myAppUrl + this.myApiUrl);
    }
}
